import { IAction } from '@/redux/actions/action-helpers'
import { TripPurposeTypes } from '@/redux/actions/actions.types'
import { ApplicationState } from '@/redux/stores/types'

export function tripPurposesReducer(state: ApplicationState['tripPurposes'] = [], action: IAction) {
	switch (action.type) {
		case TripPurposeTypes.GetTripPurposes.SUCCESS:
			return action.payload
	}

	return state
}
